function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "clip-path"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_71",
  "data-name": "Path 71",
  d: "M14.358-14a1.86,1.86,0,0,1,1.859,1.859,1.86,1.86,0,0,1-1.859,1.857A1.86,1.86,0,0,1,12.5-12.141,1.86,1.86,0,0,1,14.358-14m0,5.716a3.862,3.862,0,0,0,3.859-3.857A3.863,3.863,0,0,0,14.358-16,3.863,3.863,0,0,0,10.5-12.141a3.862,3.862,0,0,0,3.859,3.857",
  transform: "translate(-10.5 16)",
  fill: "none",
  clipRule: "evenodd"
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "clip-path-2"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_70",
  "data-name": "Path 70",
  d: "M-20,239.317H406.657V-518H-20Z",
  transform: "translate(20 518)",
  fill: "none"
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "clip-path-3"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_74",
  "data-name": "Path 74",
  d: "M23.281.24H3.315A1.62,1.62,0,0,1,1.7-1.378V-4.136L8.436-9.007l6.485,5.188a.85.85,0,0,0,1,.043l3.67-2.447L24.9-1.9v.524A1.621,1.621,0,0,1,23.281.24M3.315-17.3H23.281A1.62,1.62,0,0,1,24.9-15.685V-4.092L20.179-7.936a.852.852,0,0,0-1.007-.048L15.5-5.533l-6.506-5.2a.851.851,0,0,0-1.028-.025L1.7-6.231v-9.454A1.619,1.619,0,0,1,3.315-17.3M23.281-19H3.315A3.319,3.319,0,0,0,0-15.685V-1.378A3.319,3.319,0,0,0,3.315,1.938H23.281A3.32,3.32,0,0,0,26.6-1.378V-15.685A3.32,3.32,0,0,0,23.281-19",
  transform: "translate(0 19)",
  fill: "none",
  clipRule: "evenodd"
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "clip-path-4"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_73",
  "data-name": "Path 73",
  d: "M-20,124.856H342.173V-518H-20Z",
  transform: "translate(20 518)",
  fill: "none"
})));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "Group_996",
  "data-name": "Group 996",
  transform: "translate(11.192 3.12)",
  clipPath: "url(#clip-path)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_995",
  "data-name": "Group 995",
  transform: "translate(-40.665 -669.319)",
  clipPath: "url(#clip-path-2)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_69",
  "data-name": "Path 69",
  d: "M5.5-21H26.55V.049H5.5Z",
  transform: "translate(28.499 683.652)",
  fill: "#fff"
})));

var _ref4 = /*#__PURE__*/React.createElement("g", {
  id: "Group_998",
  "data-name": "Group 998",
  transform: "translate(0 0)",
  clipPath: "url(#clip-path-3)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_997",
  "data-name": "Group 997",
  transform: "translate(-22.636 -564.763)",
  clipPath: "url(#clip-path-4)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_72",
  "data-name": "Path 72",
  d: "M-5-24H32.915V8.256H-5Z",
  transform: "translate(21.977 583.104)",
  fill: "#fff"
})));

var SvgFileUpload = function SvgFileUpload(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_1473",
    "data-name": "Group 1473",
    width: 26.597,
    height: 20.938,
    viewBox: "0 0 26.597 20.938",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgFileUpload, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/file-upload.5a6f1bc3.svg";
export { ForwardRef as ReactComponent };